import React, { useState } from 'react'
import { Button, CheckList, Toast } from 'antd-mobile-v5'
import { WhiteSpace, WingBlank } from 'antd-mobile'
import { useHistory, useLocation } from 'react-router-dom'
import { useSubmitBindingMobile } from '../../services/hooks'
import { getParameterByName, isWechatBrowser } from '../../components/common/utils'
import { setPadiWxId } from '../../components/common/cookie'
import styles from './MobileSelection.module.css'
import { getPadiWxId } from '../../utils/user'

const MobileSelectionPage = () => {
  const {
    state: { mobileList, padiToken },
  } = useLocation()
  const { push } = useHistory()
  const [mobileSelected, setMobileSelected] = useState(() => {
    if (mobileList && mobileList.length > 0) {
      const initialValues = mobileList.find((mobile) => mobile.binding).mobile
      return initialValues
    }
    return ''
  })
  const { runAsync, loading } = useSubmitBindingMobile()

  const submit = () => {
    const padiWxId = getPadiWxId()
    const data = {
      padiToken: padiToken,
      mobile: mobileSelected,
      token: padiWxId,
    }
    runAsync(data).then((res) => {
      if (res.token) {
        Toast.show({
          icon: 'success',
          content: '绑定成功！',
          afterClose: () => {
            // 同 emailLogin：只有真在微信里才保留 openid，其余环境必须写入本次绑定拿到的新 token
            if (!isWechatBrowser()) {
              setPadiWxId(res.token)
            }
            const nextPage = getParameterByName('referer') || '/certs'
            if (nextPage.indexOf('http') === 0) {
              if (nextPage.indexOf('club-api-staging.padi') >= 0 || nextPage.indexOf('club-api.padi') >= 0) {
                let refererUrl
                if (nextPage.indexOf('?') > 0) {
                  refererUrl = nextPage + '&padiToken=' + data.token
                } else {
                  refererUrl = nextPage + '?padiToken=' + data.token
                }
                window.location.href = refererUrl
                return
              }
              window.location.href = nextPage
            } else {
              push(nextPage)
            }
          },
        })
      }
    })
  }

  return (
    <>
      <div className={styles.title}>检测到您有另外的手机账号关联了该邮箱，请选择：</div>
      <CheckList defaultValue={[mobileSelected]} onChange={(value) => setMobileSelected(value[0])}>
        {mobileList.map(
          (item) =>
            item.binding && (
              <>
                <CheckList.Item value={item.mobile}>
                  <div className={styles.tips}>增加新手机号绑定该邮箱 ：{`+${item.countryCode} ${item.mobile}`}</div>
                </CheckList.Item>
              </>
            )
        )}
        {mobileList.map(
          (item) =>
            !item.binding && (
              <>
                <CheckList.Item value={item.mobile}>
                  <div className={styles.tips}>
                    切换回历史手机号，并只保留历史手机号和邮箱的对应关系：{`+${item.countryCode} ${item.mobile}`}
                  </div>
                </CheckList.Item>
              </>
            )
        )}
      </CheckList>
      <WhiteSpace />
      <WingBlank>
        <Button block color="primary" disabled={loading} loading={loading} onClick={submit}>
          确认绑定
        </Button>
      </WingBlank>
    </>
  )
}

export default MobileSelectionPage
